import { render } from "./GiftOrder.vue?vue&type=template&id=ee9fb908&scoped=true"
import script from "./GiftOrder.vue?vue&type=script&lang=js"
export * from "./GiftOrder.vue?vue&type=script&lang=js"

import "./GiftOrder.vue?vue&type=style&index=0&id=ee9fb908&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9fb908"]])

export default __exports__